export class Sucursal{
  
   public id:number;
   public codigoConsorcio:string;
   public codigoSucursal:string;
   public nombreLargoSucursal:string;
   public nombreCortoSucursal:string;
   public numeroIdentificacion:string;
   public idReferenciaERP:string;
   public tipoSucursal:string;
   public referencia1:string;
   public referencia2:string;
   public referencia3:string;
   public referencia4:string;
   public cuit:string;
   public pais:string;
   public provincia:string;
   public ciudad:string;
   public direccion:string;
   public email:string;
   public telefono:string;
   public fax:string;
   public situacion:string;
}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/model/sucursal.ts